import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as tourActions from './../../../../../actions/tourAction';
import * as tagActions from './../../../../../actions/tagAction';
import { getAllTourPropertyAction } from './../../../../../actions/propertyAction'
import {uploadAction, uploadReset} from './../../../../../actions/uploadAction';
import {getListProvinces} from './../../../../../actions/generalAction';
import {getSupplierListAll, getSupplierSelectList} from './../../../../../actions/supplierAction';
import action from "../../../../../actions";
import TourDetail from './TourDetail';

const mapStateToProps = state => {
    return {
        tourState: state.tourReducer,
        uploadState: state.uploadReducer,
        generalState: state.generalReducer,
        supplierState: state.supplierReducer,
        property: state.propertyReducer,
        tagGroupState: state.tagGroupReducer,
        tagGroupDetailState: state.tagGroupDetailReducer,
        autoTranslateState: state.autoTranslateReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTourDetail: (id) => dispatch(tourActions.getTourDetail(id)),
        setTourDetail: (tour) => dispatch(tourActions.setTourDetail(tour)),
        updateTour: (tour) => dispatch(tourActions.updateTour(tour)),
        createTour: (tour) => dispatch(tourActions.createTour(tour)),
        uploadFile: (filters) => dispatch(uploadAction(filters)),
        uploadReset: () => dispatch(uploadReset()),
        //TOUR TYPES
        getAllTourTypes: () => dispatch(tourActions.getAllTourTypes()),
        createTourType: (tourType) => dispatch(tourActions.createTourType(tourType)),
        updateTourType: (tourType) => dispatch(tourActions.updateTourType(tourType)),
        deleteTourType: (tourType, refreshParams) => dispatch(tourActions.deleteTourType(tourType, refreshParams)),
        //TOUR LINES
        getListTourLines: (tourId, params, isTour) => dispatch(tourActions.getListTourLines(tourId, params, isTour)),
        createTourLine: (tourLine, refreshParams, tour) => dispatch(tourActions.createTourLine(tourLine, refreshParams, tour)),
        createTourLinesBulk: (tourLineBulk, refreshParams) => dispatch(tourActions.createTourLinesBulk(tourLineBulk, refreshParams)),
        updateTourLinesBulk: (tourLineBulk, refreshParams) => dispatch(tourActions.updateTourLinesBulk(tourLineBulk, refreshParams)),
        deleteTourLinesBulk: (tourLines, refreshParams) => dispatch(tourActions.deleteTourLinesBulk(tourLines, refreshParams)),
        updateTourLine: (tourLine, refreshParams, tour) => dispatch(tourActions.updateTourLine(tourLine, refreshParams, tour)),
        deleteTourLine: (tourLine, refreshParams, tour) => dispatch(tourActions.deleteTourLine(tourLine, refreshParams, tour)),
        getProvinces: (countryCode) => dispatch(getListProvinces(countryCode)),
        getItemTicket: (params) => dispatch(tourActions.getItemTicket(params)),
        setOpenTourlineBulk: (isOpen) => dispatch(tourActions.openTourlineBulk(isOpen)),
        //SUPPLIER:
        getSupplierSelectList: () => dispatch(getSupplierSelectList()),
        getSupplierListAllForVW: (productType) => dispatch(getSupplierListAll(productType)),
        //TRANSLATE:
        createTourTranslate: (tour, language) => dispatch(tourActions.createTourTranslate(tour, language)),
        updateTourTranslate: (tour, language) => dispatch(tourActions.updateTourTranslate(tour, language)),
        deleteTourTranslate: (tour, refreshParams) => dispatch(tourActions.deleteTourTranslate(tour, refreshParams)),
        // onListAllProperties: () => dispatch(action.dataAllPropertyAction()),
        onListAllProperties: () => dispatch(getAllTourPropertyAction()),
        getDetailTourTicket: (params) => dispatch(tourActions.getDetailTourTicketAction(params)),
        //Tags
        getAllTagGroup: () => dispatch(tagActions.getAllTagGroup()),
        getTagBySku: (id) => dispatch(tagActions.getTagBySku(id)),
        getTagInTagroup: (params) => dispatch(tagActions.getTagInTagroup(params)),
        updateTagGroupSKUMapping: (skuTags) => dispatch(tagActions.updateTagGroupSKUMapping(skuTags)),
        setTagBySku: (skuTags) => dispatch(tagActions.setTagBySku(skuTags)),
        setAllTagGroup: (allTag) => dispatch(tagActions.setAllTagGroup(allTag)),

        //VWSKU tags
        getAllTagSKUVW: () => dispatch(tourActions.getAllTagSKUVW()),
        createTagSKUVW: (tag) => dispatch(tourActions.createTagSKUVW(tag)),
        updateTagSKUVW: (tag) => dispatch(tourActions.updateTagSKUVW(tag)),
        deleteTagSKUVW: (tag, refreshParams) => dispatch(tourActions.deleteTagSKUVW(tag, refreshParams)),
        
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TourDetail));
